let result: boolean | undefined;

export const doesBrowserAutoOrientImages = async () => {

    if (result !== undefined) {
        return result;
    }

    return new Promise<boolean>(resolve => {

        const img = document.createElement('img');

        img.onload = () => {
            result = img.width === 2 && img.height === 3;
            resolve(result);
        };

        // black+white 3x2 JPEG, with the following meta information set:
        // - EXIF Orientation: 6 (Rotated 90° CCW)
        // Image data layout (B=black, F=white):
        // BFF
        // BBB
        img.src = 'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA'
            + 'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA'
            + 'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE'
            + 'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/x'
            + 'ABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAA'
            + 'AAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQ'
            + 'voP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXw'
            + 'H/9k=';
    });
};